<div class="row">
    <div class="col-sm-12">
        <div class="container-white">
            <div class="ui-progress-status-bar" *ngIf="dontShowSummary">
                <ol>
                  <li class="">
                    <span class="stepnum">1</span>
                    Select
                  </li>
                  <li class="current">
                    <span class="stepnum">2</span>
                    Review
                  </li>
                </ol>
            </div>
            <div style="margin-top: 20px;margin-bottom: 20px;">
                <h4>Safe Harbor Plans</h4>
            </div>

            <div *ngIf="shSelected">
                <span [hidden]="dontShowSummary">
                <p><b>Notice(s) Successfully generated for  {{shSelected.length}} Subgroup(s). It will be released on {{ shReleaseDate }}</b>
                </span>
            </div>

            <div *ngIf="showConfirmMessage">
                <div *ngIf="shSelected">
                    <section *ngIf="alert">
                        <div class="row">
                        <div class="col-xs-12">
                            <div class="ui-alert ui-alert-info">
                            <div class="alert-content">
                                <strong>{{ alert.caption }}</strong>
                                <span *ngIf="alert.caption">&nbsp;</span>
                                <span *ngIf="alert.text" [innerHTML]="alert.text"></span>
                            </div>
                            </div>
                        </div>
                        </div>
                    </section>

                    <b>Total Notices Produced: {{shSelected.length}} </b>
                    <ul>
                        <li *ngFor="let selected of shSelected">
                        {{selected.CoopName}}
                        </li>
                    </ul>

                    <div style="margin-top: 20px;">
                        <button (click)="navigateBack()" class="btn btn-primary">Back</button>&nbsp;&nbsp;
                        <button (click)="submitSubgroups()" class="btn btn-primary">Confirm</button>
                    </div>        
                </div>
            </div>
        </div>
        <br />
    </div>
</div>